import section3Img from "./section3_img.webp";
import classes from "./Section3.module.css";
import { section3Data } from "../../../data/home";

export default function Section3() {
  return (
    <section className={classes.section}>
      <div className={classes.panel}>
        <div className={classes.imageWrap}>
          <img
            src={section3Img}
            alt="Mini C-Arm imaging for guided injections"
            className={classes.media}
            loading="lazy"
          />
        </div>

        <div className={classes.content}>
          <div className={classes.inner}>
            <h2 className={classes.heading}>
              Our Mini C-Arm Injections Main Perks
            </h2>

            <p className={classes.paragraph}>
              Our Mini C-Arm provides precise imaging guidance for injections,
              helping healthcare professionals improve accuracy, workflow, and
              patient comfort during procedures.
            </p>

            <div className={classes.features}>
              {section3Data.map((feature, index) => (
                <article
                  className={classes.feature}
                  key={feature.title}
                >
                  {feature.icon && (
                    <span className={classes.featureIcon} aria-hidden="true">
                      {feature.icon}
                    </span>
                  )}

                  <div className={classes.featureText}>
                    <h3 className={classes.featureTitle}>{feature.title}</h3>

                    <p className={classes.featureDescription}>
                      {feature.description}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
